import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-120ef75c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-nav__container" }

import type { VNode } from 'vue';
import type { TabsPaneContext } from './constants';

import { flattedChildren } from '@/utils/vnode';
import { symbolTabsRootKey } from './constants';

import {
  ref,
  getCurrentInstance,
  isVNode,
  provide,
  watch,
} from 'vue';


const __default__ = {
  name: 'HeaderTabs',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {}
  },
  emits: ['update:value', 'tab-change'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const childrenList = ref<TabsPaneContext[]>([]);
const children: Record<number, TabsPaneContext> = {};
const currentInstance = getCurrentInstance()!;
const currentName = ref(props.value);

const addChild = (child: TabsPaneContext) => {
  children[child.uid] = child;
  childrenList.value = getOrderedChildren(children);
};
const removeChild = (uid: number) => {
  delete children[uid];
  childrenList.value = childrenList.value.filter(
    (children) => children.uid !== uid
  );
};

const getOrderedChildren = (children: Record<number, TabsPaneContext>) => {
  const nodes = flattedChildren(currentInstance.subTree).filter(
    (n): n is VNode => isVNode(n) && !!n.component
  );
  const uids = nodes.map((n) => n.component!.uid);
  return uids.map((uid) => children[uid]).filter((p) => !!p);
};

watch(currentName, (value, oldValue) => {
  emit('update:value', value);
  emit('tab-change', value, oldValue);
});

provide(symbolTabsRootKey, {
  props,
  currentName,
  addChild,
  removeChild,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})